// third-party
import { FormattedMessage } from 'react-intl';

// assets
import RobotOutlined from '@ant-design/icons/RobotOutlined';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { RobotOutlined };

// ==============================|| MENU ITEMS - MESSAGES DASHBOARD ||============================== //

const messagesDashboard: NavItemType = {
  id: 'message-center',
  title: <FormattedMessage id="ai-affiliate-dm" />,
  type: 'group',
  url: '/message-center',
  icon: icons.RobotOutlined
};

export default messagesDashboard;
